export default __webpack_public_path__ + "static/backstage-integrate-dx-eca9f9614bb51a326822851346bdcf18.png";